import React from 'react'

const conditions = (condition, value1, value2) => {
  switch(condition){
    case "=": return value1 === value2
    case "<>": return value1 !== value2
    default: return 
  }
}

const validateList = (listValidations, otherValues) => {

  return listValidations.find(v => {
    return false === conditions(v.teste, v.valor, otherValues ? otherValues[v.campo] : null)
  }) ? false : true;
}

const validate = (validacoes, otherValues) => {
  let result = {};

  for(let key in validacoes){
    switch(key){
      case "obrigatorio": result = {...result, ...{[key]: validateList(validacoes[key], otherValues)}}; break;
      case "visivel": result = {...result, ...{[key]: validateList(validacoes[key], otherValues)}}; break;
      default: break;
    }
  } 

  return result;
}

export const CheckObligation = ({steps, children, fieldConditional, fieldKey}) => {
  let field = null;
  //let steps = props.currentStep.Campos.filter(e=>e);

  if (steps)
    field = steps.find((c) => {
      return c.chave === fieldKey;
    })
  
  let resultadoValidacao = {};
  if (field) {
    let showChildren = true;
    if (field.validacoes) {
      resultadoValidacao = validate(field.validacoes, fieldConditional);

      let { visivel } =  resultadoValidacao;
      if(visivel === false) showChildren = false;   
    } else {
      resultadoValidacao = field;
    }

    return (
      <>
        {showChildren && children(resultadoValidacao)}
      </>
    )
  } else return null;
}
